var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"layout-auth-sample"},[_c('v-main',[_c('v-container',{staticClass:"fill-height pa-0",attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1)],1),_c('x-show-message')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }